export default class DataUtil {

  static desformataData(data: any) {
    if (!data) {
      return;
    }
    const date = new Date();
    if (typeof data === 'object') {
      return data;
    }
    date.setFullYear(data.substring(0, 4));
    date.setMonth(data.substring(5, 7) - 1);
    date.setDate(data.substring(8, 10));
    return date;
  }

  //yyyy-mm-ddTHH:mm:ss
  static desformataDataTempo(data: any) {
    if (!data) {
      return;
    }
    const date = new Date();
    if (typeof data === 'object') {
      return data;
    }
    date.setFullYear(data.substring(0, 4));
    date.setMonth(data.substring(5, 7) - 1);
    date.setDate(data.substring(8, 10));
    date.setHours(data.substring(11, 13));
    date.setMinutes(data.substring(14, 16));
    return date;
  }

  static formataData(data: any) {
    if (!data) {
      return '';
    }
    const tempData = this.desformataData(data);
    const dia = String(tempData.getDate()).padStart(2, '0');
    const mes = String(tempData.getMonth() + 1).padStart(2, '0');
    const ano = tempData.getFullYear();
    return `${ano}-${mes}-${dia}`
  }

  static formataLocalDateTime(data: any, zeraHora = false) {
    if (!data) {
      return '';
    }
    const tempData = this.desformataData(data);
    const dia = String(tempData.getDate()).padStart(2, '0');
    const mes = String(tempData.getMonth() + 1).padStart(2, '0');
    const ano = tempData.getFullYear();
    const hours = String(tempData.getHours()).padStart(2, '0');
    const minutes = String(tempData.getMinutes()).padStart(2, '0');
    const seconds = String(tempData.getSeconds()).padStart(2, '0');
    if (zeraHora) {
      return `${ano}-${mes}-${dia}T00:00:00`;
    }
    return `${ano}-${mes}-${dia}T${hours}:${minutes}:${seconds}`;
  }

  static formataData2(data: any) {
    if (!data) {
      return '';
    }
    const tempData = this.desformataData(data);
    const dia = String(tempData.getDate()).padStart(2, '0');
    const mes = String(tempData.getMonth() + 1).padStart(2, '0');
    const ano = tempData.getFullYear();
    return `${dia}/${mes}/${ano}`
  }

  static formataDataTempo(data: any) {
    if (!data) {
      return '';
    }
    const tempData = this.desformataDataTempo(data);
    const dia = String(tempData.getDate()).padStart(2, '0');
    const mes = String(tempData.getMonth() + 1).padStart(2, '0');
    const ano = tempData.getFullYear();
    const hours = String(tempData.getHours()).padStart(2, '0');
    const minutes = String(tempData.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${hours}:${minutes}`
  }


  static formataTempo(data: any) {
    if (!data) {
      return '';
    }
    const tempData = this.desformataDataTempo(data);
    const hours = String(tempData.getHours()).padStart(2, '0');
    const minutes = String(tempData.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`
  }

  static datePlusDays(date: any, days: any) {
    const temp = new Date(date);
    temp.setDate(temp.getDate() + days);
    return temp;
  }

  static dateMinusDays(date: any, days: any) {
    const temp = new Date(date);
    temp.setDate(temp.getDate() - days);
    return temp;
  }


  static datePlusMinutes(date: any, minutes: any) {
    const temp = new Date(date);
    temp.setMinutes(temp.getDate() + minutes);
    return temp;
  }

  static dateMinusMinutes(date: any, minutes: any) {
    const temp = new Date(date);
    temp.setMinutes(temp.getMinutes() - minutes);
    return temp;
  }

  static isBefore(from: any, to: any) {
    if (!from || !to) {
      return undefined;
    }
    return from.getTime() < to.getTime();
  }

  static isAfter(from: any, to: any) {
    if (!from || !to) {
      return undefined;
    }
    return from.getTime() > to.getTime();
  }

  static equals(from: any, to: any) {
    if (!from || !to) {
      return undefined;
    }
    return from.getTime() === to.getTime();
  }
}
